/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var EmailFillIcon = function EmailFillIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7C2 5.34315 3.34315 4 5 4H19C20.6569 4 22 5.34315 22 7V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7ZM6.1097 7.20743C5.67195 6.87069 5.0441 6.95258 4.70736 7.39034C4.37063 7.82809 4.45252 8.45594 4.89028 8.79267L10.1709 12.8547C11.2492 13.6842 12.7508 13.6842 13.8291 12.8547L19.1097 8.79267C19.5475 8.45594 19.6293 7.82809 19.2926 7.39034C18.9559 6.95258 18.328 6.87069 17.8903 7.20743L12.6097 11.2694C12.2502 11.5459 11.7497 11.5459 11.3903 11.2694L6.1097 7.20743Z"
  }));
};
export default EmailFillIcon;